import { Channel, ChannelUppercase } from 'features/Yucollect/utils/types';
import {
  TASK_TYPES,
  TaskType,
} from 'redux/slice/supervisor-dashboard/SupervisorDashboard.slice';
import { ReportType } from 'redux/types/Reports.types';

const localHostName = `http://localhost:8080`;

const env = process.env.REACT_APP_ENV || 'qa';
export const YUBI_GATEWAY_URL = `https://${env}-yubi-gateway.yucollect${
  env === 'prd' ? '.com' : '.in'
}`;
const hostName = window.origin;

export const SSE_BASE_URL = `${YUBI_GATEWAY_URL}/ucf-mobile-service/ucf/api/v1/sse`;

const platformURLs: { [key: string]: string } = {
  qa: `https://qa-yubi-gateway.yucollect.in/authweb`,
  uat: `https://auth-api-uat.yucollect.in`,
  prd: `https://identity-api.yucollect.com`,
  staging: `https://auth-api-stg.yucollect.in`,
  stg: `https://auth-api-stg.yucollect.in`,
};

const applicationURLs: { [key: string]: string } = {
  qa: `https://qa-mumbai.yucollect.in`,
  uat: `https://uat-mumbai.yucollect.in`,
  prd: `https://https://app.yucollect.com`,
  staging: `https://stg-mumbai.yucollect.in`,
  stg: `https://stg-mumbai.yucollect.in`,
  local: `http://localhost:5001`,
};

export const applicationURL = applicationURLs[env] || applicationURLs.local;

const moodleURLs: { [key: string]: string } = {
  qa: `https://qa-moodle.yucollect.in`,
  uat: `https://qa-moodle.yucollect.in`,
  prd: `https://moodle.yucollect.com`,
  stg: `https://qa-moodle.yucollect.in`,
};

const platformURL = platformURLs[env] || platformURLs.qa;
const moodleURL = moodleURLs[env] || moodleURLs.qa;

// YUBI GATEWAY URLS
const epsURL = `${YUBI_GATEWAY_URL}/eps-service`;
const ingestionURL = `${YUBI_GATEWAY_URL}/ingestion-service`;
const cmsURL = `${YUBI_GATEWAY_URL}/content-management`;
const ihsURL = `${YUBI_GATEWAY_URL}/ihs-data-service`;
const ucfURL = `${YUBI_GATEWAY_URL}/ucf-service`;
const lrsURL = `${YUBI_GATEWAY_URL}/lrs-service`;

export const phygitalURL = `${YUBI_GATEWAY_URL}/ucf-service/phygital`;
export const telephonyURL = `${YUBI_GATEWAY_URL}/ucf-service/ucf/telephony`;

// External
export const tubelightURL = `https://${env}-tubelight-service.yucollect${
  env === 'prd' ? '.com' : '.in'
}`;

export const getTenantName = () => {
  return env === 'qa'
    ? 'qayucollect'
    : env === 'stg' || env === 'staging'
    ? 'stagngyucollect'
    : env === 'uat'
    ? 'yubi'
    : env === 'prd'
    ? 'yucollect'
    : 'qayucollect';
};

export const TENANT_NAME = getTenantName();

const plannerURL = `${YUBI_GATEWAY_URL}/planning-service/planning-service/api/v1`;
const plannerURLForDigital = `${YUBI_GATEWAY_URL}/planning-service/digital-summary/api/v1`;
const advancePlannerURL = `${YUBI_GATEWAY_URL}/campaign-planner-service/advance-planning-service`;
const campaignURL = `${YUBI_GATEWAY_URL}/campaign-planner-service`;
const orchestratorURL = `${YUBI_GATEWAY_URL}/orchestrator-service`;
const emsAgencyOnBoardingURL = `${YUBI_GATEWAY_URL}/ems-service/collections/ems/agency-onboarding/api/v1`;
export const emsAgencyOnBoardingNoAuthURL = `${YUBI_GATEWAY_URL}/ems-service-no-auth/collections/ems/agency-onboarding/api/v1`;
// export const emsAgencyOnBoardingNoAuthURLV2 = `${YUBI_GATEWAY_URL}/ems-service-no-auth/collections/ems/agency-onboarding/api/v1`;
export const emsURL = `${YUBI_GATEWAY_URL}/ems-service/collections`;
export const emsServiceURL = `${YUBI_GATEWAY_URL}/ems-service`;

export const agencyAllocatorConfigEndpoints = {
  AGENCY_ALLOCATOR_CONFIG: `${emsURL}/ems/api/v1/agency-allocator-config`,
};
const discoveryURL = `${YUBI_GATEWAY_URL}/ems-service/discovery`;
const discoveryNoAuthURL = `${YUBI_GATEWAY_URL}/ems-service-no-auth/discovery`;
const campaignUrl = campaignURL;
export const agentOnboardingTemplateURL =
  'https://qa-assets.yucollect.in/assets/templates/Agent_Onboarding_Template.xlsx';

const allocationEngineBaseURL = `${hostName}/collections/allocations`;

const contentManagementBaseURL = `${cmsURL}/collections`;

const emsBaseUrl = `${hostName}/collections/ems`;

const epsBaseUrl = `${epsURL}/collections/eps`;
const reportsURL = `${YUBI_GATEWAY_URL}/ihs-data-service/reports/api/v1`;

// INDIVIDUAL SERVICE URLS
// const epsURL = `https://${env}-entitypreference-service.yucollect.in`;
// const ingestionURL = `https://${env}-yucollect-ingestion-service.yucollect.in`;
// const cmsURL = `https://${env}-contentmanagement-service.yucollect.in`;
// const ihsURL = `https://${env}-ihs-data-service.yucollect.in`;
// const ucfURL = `https://${env}-yucollect-ucf-service.yucollect.in`;

// export const phygitalURL = `${ucfURL}/phygital`;
// // export const phygitalWebSocketURL = `${YUBI_GATEWAY_URL}/ucf-service-no-auth`;
// export const phygitalWebSocketURL = `https://${env}-yucollect-ucf-service.yucollect.in`;
// export const telephonyURL = `${ucfURL}/ucf/telephony`;

// // External
// export const tubelightURL = `https://${env}-tubelight-service.yucollect.in`;

// const plannerURL = `https://${env}-planning-service.yucollect.in/planning-service/api/v1`;
// const advancePlannerURL = `https://${env}-campaign-planner.yucollect.in/advance-planning-service`;
// const campaignURL = `https://${env}-campaign-planner.yucollect.in`;
// const orchestratorURL = `https://${env}-campaign-orchestrator.yucollect.in`;
// const emsAgencyOnBoardingURL = `https://${env}-ems-service.yucollect.in/collections/ems/agency-onboarding/api/v1`;
// const emsAgencyOnBoardingNoAuthURL = `https://${env}-ems-service.yucollect.in/collections/ems/agency-onboarding/api/v1`;
// export const emsURL = `https://${env}-ems-service.yucollect.in/collections`;
// const discoveryURL = `https://${env}-ems-service.yucollect.in/discovery`;
// const discoveryNoAuthURL = `https://${env}-ems-service.yucollect.in/discovery`;
// const campaignUrl = campaignURL;
// export const agentOnboardingTemplateURL = `https://${env}-mumbai.yucollect.in/assets/Agent_Onboarding_Template.xlsx`;
// const allocationEngineBaseURL = `${hostName}/collections/allocations`;

// const contentManagementBaseURL = `${cmsURL}/collections`;

// const emsBaseUrl = `${hostName}/collections/ems`;

// const epsBaseUrl = `${epsURL}/collections/eps`;
// const reportsURL = `https://${env}-ihs-data-service.yucollect.in/reports/api/v1`;

const redirectServiceUrl = {
  CRM_URL: `https://crm-${env}.spocto.com/#/app/crm/dashboard`,
  UNSUBSCRIBE_URL: `https://crm-${env}.spocto.com/#/app/file`,
};

interface AllocationEngineEndpoints {
  CREATE_ALLOCATION_CONFIG: string;
  GET_CREATED_ALLOCATION_CONFIG_LIST: (lenderId: string) => string;
  UPDATE_ALLOCATION_CONFIG: (configId: string) => string;
  CREATE_ALLOCATION: string;
  GET_ALLOCATION_BY_ID: (allocationId: string) => string;
  ASSIGN_ALLOCATION: string;
  RE_ASSIGN_ALLOCATION: string;
  GET_DERIVED_FIELDS: (lenderId: string, allocationId?: string) => string;
  GET_ALLOCATION_CONFIG: (configId: string) => string;
  GET_GROUPED_ALLOCATIONS_NUMBERS: (lenderId: string) => string;
  GET_ALLOCATION_LIST: (lenderId: string) => string;
  GET_FILTER_OPTIONS: (lenderId: string) => string;
  GET_EXTRACTION_STATUS: string;
  DEALLOCATE_ALLOCATION: string;
  GET_PAYMENT_STATUS: string;
  GET_COVERED_RECORDS: string;
}
export const MOODLE_LOGIN_URL = (
  email: string | undefined,
  name: string | undefined,
  lname: string | undefined
) =>
  `${moodleURL}/learning/webservice/web_auth.php?id=${email}&name=${name}&lname=${lname}`;

const userEndpoints = {
  GET_USER_PERMISSION: `${emsURL}/platform/user/permissions`,
  GET_USER_PERMISSION1: (entityId: string) =>
    `${platformURL}/v3/users/${entityId}/all_permissions?product_id=YUC&includes=privileges`,
  // GET_USER_ENTITIES: `${emsURL}/platform/user/entities`,
  GET_USER_ENTITIES: `${platformURL}/v3/users/me?product_id=YUC&includes=all_entities`,
  SEARCH_USER: (searchCriteria: string) =>
    `${epsBaseUrl}/api/v1/users/search?keyword=${searchCriteria}`,
  GET_SUPERSET_TOKEN: (dashboardType: string) =>
    `${hostName}/collections/dashboard/integration/token?dashboardType=${dashboardType}`,
  UNBLOCK_USER: (userId: string) =>
    `${platformURL}/drona_hq/users/${userId}/unblock?product_id=USRPTF`,
};

const manageAgency = {
  REMIND_URL: `${emsBaseUrl}/api/v1/lender/agencies/invite/remind`,
  GET_AGENCY_LIST: `${emsBaseUrl}/api/v1/lender/association/agencies/my-agency`,
  REINVITE_URL: `${emsBaseUrl}/api/v1/lender/agencies/invite/re-invite`,
  INVITE_ACTION_URL: `${emsBaseUrl}/api/v1/lender/agencies/invite`,
  AGENCY_LIST_URL: `${emsBaseUrl}/api/v1/lender/association/agencies`,
  SEND_ASSOCIATION_REQUEST_URL: `${emsBaseUrl}/api/v1/lender/agencies/associate`,
  FILTER_OPTIONS: `${emsBaseUrl}/api/v1/lender/association/agencies/filter`,
};
const allocationEngineEndpoints: AllocationEngineEndpoints = {
  GET_ALLOCATION_BY_ID: (allocationId: string) =>
    `${allocationEngineBaseURL}/allocationConfig/getAllocationForAllocationId/${allocationId}`,
  CREATE_ALLOCATION: `${allocationEngineBaseURL}/allocationConfig/createAllocation`,
  CREATE_ALLOCATION_CONFIG: `${allocationEngineBaseURL}/allocationConfig/saveAllocationAsConfig`,
  UPDATE_ALLOCATION_CONFIG: (configId) =>
    `${allocationEngineBaseURL}/allocationConfig/updateAllocationConfig/${configId}`,
  GET_CREATED_ALLOCATION_CONFIG_LIST: (lenderId) =>
    `${allocationEngineBaseURL}/allocationConfig/getCreatedAllocationConfigs/${lenderId}`,
  ASSIGN_ALLOCATION: `${allocationEngineBaseURL}/allocationConfig/assignAllocation`,
  RE_ASSIGN_ALLOCATION: `${allocationEngineBaseURL}/allocationConfig/reallocateAllocation`,
  GET_ALLOCATION_CONFIG: (configId: string) =>
    `${allocationEngineBaseURL}/allocationConfig/getAllocationConfigForAllocationConfigId/${configId}`,
  GET_DERIVED_FIELDS: (lenderId: string, allocationId?: string) =>
    allocationId
      ? `${allocationEngineBaseURL}/allocationConfig/getAllColumnsWithDistinctValue/${lenderId}?allocationId=${allocationId}`
      : `${allocationEngineBaseURL}/allocationConfig/getAllColumnsWithDistinctValue/${lenderId}`,
  GET_GROUPED_ALLOCATIONS_NUMBERS: (lenderId: string) =>
    `${allocationEngineBaseURL}/allocationConfig/listAllocationNumbersGroupedByType/${lenderId}`,
  GET_ALLOCATION_LIST: (lenderId: string) =>
    `${allocationEngineBaseURL}/allocationConfig/listAllocationsGroupedByType/${lenderId}`,
  GET_FILTER_OPTIONS: (lenderId: string) =>
    `${allocationEngineBaseURL}/allocationConfig/getFilters/${lenderId}`,
  GET_EXTRACTION_STATUS: `${allocationEngineBaseURL}/allocationConfig/getExtractionRunStatus`,
  DEALLOCATE_ALLOCATION: `${allocationEngineBaseURL}/allocationConfig/deAllocateAllocation`,
  GET_PAYMENT_STATUS: `${allocationEngineBaseURL}/allocationConfig/getPaymentRunStatus`,
  GET_COVERED_RECORDS: `${allocationEngineBaseURL}/allocationConfig/getFilterResultForAllocationRecords`,
};

// Yucollect End-Points
const allocationEndpoints = {
  UPLOAD_ALLOCATION: (vendorId: string) =>
    `${ingestionURL}/agencies/${vendorId}/allocations/upload`,
  // GET_ALLOCATION_LIST: (vendorId: string, page: number, pageSize: number) =>
  //   `${ingestionURL}/agencies/${vendorId}/allocations?page=${page}&pageSize=${pageSize}`,
  GET_ALLOCATION_LIST: (vendorId: string, page: number, pageSize: number) =>
    `${ingestionURL}/api/v2/agencies/${vendorId}/allocations?page=${page}&pageSize=${pageSize}`,
  GET_ALLOCATOR_ALLOCATION_LIST: (page: number, pageSize: number) =>
    `${ingestionURL}/api/v2/allocators/allocations?page=${page}&pageSize=${pageSize}`,
  GET_ALLOCATION_ID_DETAILS: (allocationId: string) =>
    `${ingestionURL}/allocations/${allocationId}`,
  UPLOAD_PAYMENT_FILE: (vendorId: string) =>
    `${ingestionURL}/agencies/${vendorId}/payments/upload`,
  BULK_PAYMENT_UPLOAD: (allocatorId: string) =>
    `${ingestionURL}/allocators/${allocatorId}/payments/bulk-upload`,
  GET_BULK_PAYMENT_HISTORY: (allocatorId: string) =>
    `${ingestionURL}/allocators/${allocatorId}/bulk-payment-files`,
  DOWNLOAD_BULK_PAYMENT_FILE: (allocatorId: string, bulkPaymentId: string) =>
    `${ingestionURL}/allocators/${allocatorId}/bulk-payment-files/${bulkPaymentId}/download`,
  BULK_ALLOCATION_UPLOAD: `${ingestionURL}/allocations/bulk-upload`,
  GET_BULK_ALLOCATION_LIST: (page: number, pageSize: number) =>
    `${ingestionURL}/api/v3/allocators/allocations?page=${page}&pageSize=${pageSize}`,
  GET_BULK_ALLOCATION_DETAIL: (
    bulkUploadId: string,
    page: number,
    pageSize: number
  ) =>
    `${ingestionURL}/allocations/bulk/${bulkUploadId}/allocations-list?page=${page}&pageSize=${pageSize}`,
  GET_PAYMENT_LIST: (allocationId: string, page: number, pageSize: number) =>
    `${ingestionURL}/allocations/${allocationId}/payment-files?page=${page}&pageSize=${pageSize}`,
  GET_COLUMN_MAPPING: `${ingestionURL}/column-mapping/filter`,
  GET_ALLOCATION_DATA: (allocationId: string, limit: number, offset: number) =>
    `${plannerURL}/getAllocateData?limit=${limit}&offset=${offset}`,
  UPLOAD_HISTORY_FILE: (agencyId: string) =>
    `${ingestionURL}/agencies/${agencyId}/history/upload`,
  GET_ALLOCATION_DETAILS: (
    allocationId: string,
    isClosed: boolean,
    isValid: boolean,
    limit: number,
    offset: number
  ) =>
    `${plannerURL}/data-grid?allocationId=${allocationId}&isClosed=${isClosed}&isValid=${isValid}&limit=${limit}&offset=${offset}`,
  GET_ALLOCATION_DETAIL_HEADERS: (allocationId: string) =>
    `${plannerURL}/headers?allocationId=${allocationId}`,
  GET_ALLOCATION_DETAIL_SUMMARY: (
    allocationId: string,
    isClosed: boolean,
    isValid: boolean
  ) =>
    `${plannerURL}/summary?allocationId=${allocationId}&isClosed=${isClosed}&isValid=${isValid}`,
  GET_UNIQUE_VALUES_BY_COLUMN: (
    allocationId: string,
    isClosed: boolean,
    isValid: boolean,
    limit: number,
    offset: number
  ) =>
    `${plannerURL}/distinct?allocationId=${allocationId}&isClosed=${isClosed}&isValid=${isValid}&limit=${limit}&offset=${offset}`,
  SEARCH_IN_FILTER_BY_VALUES: (
    allocationId: string,
    isClosed: boolean,
    isValid: boolean
  ) =>
    `${plannerURL}/search?allocationId=${allocationId}&isClosed=${isClosed}&isValid=${isValid}`,
  ASSIGN_CHANNEL: (allocationId: string, isClosed: boolean, isValid: boolean) =>
    `${plannerURL}/assign-channel?allocationId=${allocationId}&isClosed=${isClosed}&isValid=${isValid}`,
  MERGE_HISTORIC_DATA: (allocationId: string) =>
    `${plannerURL}/merge-historic-data?allocationId=${allocationId}`,
  SEARCH_IN_DATAGRID: (
    allocationId: string,
    isClosed: boolean,
    isValid: boolean,
    limit: number,
    offset: number
  ) =>
    `${plannerURL}/global-search?allocationId=${allocationId}&isClosed=${isClosed}&isValid=${isValid}&limit=${limit}&offset=${offset}`,
  GET_CHANNLE_PLANNER_METRICS: (
    allocationId: string,
    isClosed: boolean,
    isValid: boolean
  ) =>
    `${plannerURL}/channel-allocation-summary?allocationId=${allocationId}&isClosed=${isClosed}&isValid=${isValid}`,
  DOWNLOAD_ALLOCATION_EXCEL_FILE: (allocationId: string, isValid: boolean) =>
    `${plannerURL}/download-excel-file?allocationId=${allocationId}&isValid=${isValid}`,
  ALLOCATION_SUMMARY: (allocationId: string) =>
    `${YUBI_GATEWAY_URL}/planning-service/allocation-dashboard/api/v1/report?allocationId=${allocationId}`,
  REPEAT_ALLOCATION_DASHBOARD: (
    allocationId: string,
    agencyId: string,
    allocatorId: string
  ) =>
    `${ihsURL}/dashboard-service/api/v1/repeat-allocation-dashboard?agencyId=${agencyId}&allocationId=${allocationId}&allocatorId=${allocatorId}`,
  GET_AUTO_ASSIGN_STATUS: (allocationId: string) =>
    `${phygitalURL}/auto-assign-status/${allocationId}`,
  DELETE_ALLOCATION: (allocationId: string) =>
    `${ingestionURL}/allocations/${allocationId}`,
  DELETE_BULK_ALLOCATION: (bulkAllocationId: string) =>
    `${ingestionURL}/allocations/bulk/${bulkAllocationId}`,
  ADD_NEW_ACCOUNTS: (allocationId: string) =>
    `${ingestionURL}/allocations/${allocationId}/add-new-accounts`,
  UPLOAD_UNSUBSCRIBE_FILE: (allocationId: string) =>
    `${ingestionURL}/allocations/${allocationId}/unsub`,
  GET_ALLOCATION_DISPOSITION_STATUS: (agencyId: string, allocationId: string) =>
    `${ihsURL}/${agencyId}/${allocationId}/interactions/exist`,
  DOWNLOAD_SAMPLE_ALLOCATION: () =>
    `${ingestionURL}/column-mapping/download-excel`,
  DOWNLOAD_SAMPLE_HISTORY_FILE: () =>
    `${ingestionURL}/histories/template/download`,
  GET_ALLOCATION_LIST_DISTINCT_VALUES: (agencyId: string, columnName: string) =>
    `${ingestionURL}/api/v2/agencies/${agencyId}/allocations/distinct-values?columnName=${columnName}`,
  GET_ALLOCATION_LIST_DISTINCT_VALUES_FOR_CREATED_ON: (agencyId: string) =>
    `${ingestionURL}/api/v2/agencies/${agencyId}/allocations/distinct-values?columnName=createdOn`,
  GET_ALLOCATION_LIST_DISTINCT_VALUES_FOR_UPLOADED_BY: (agencyId: string) =>
    `${ingestionURL}/api/v2/agencies/${agencyId}/allocations/distinct-values?columnName=uploadedBy`,
  GET_ALLOCATION_LIST_DISTINCT_VALUES_FOR_UPLOADER: (agencyId: string) =>
    `${ingestionURL}/api/v2/agencies/${agencyId}/allocations/distinct-values?columnName=uploader`,
};

const callPlannerEndPoints = {
  GET_CALL_PLANNER_DETAILS: (
    allocationId: string,
    channel: ChannelUppercase,
    ungrouped: boolean,
    groupId: string,
    isAllocated: boolean,
    limit: number,
    offset: number
  ) =>
    `${phygitalURL}/allocation/api/v1/allocation-file/${allocationId}?channel=${channel}&ungrouped=${ungrouped}&isAllocated=${isAllocated}&groupId=${groupId}&limit=${limit}&offset=${offset}`,
  GET_CALL_PLANNER_HEADERS: (allocationId: string, channel: ChannelUppercase) =>
    `${phygitalURL}/allocation/api/v1/allocation-file/${allocationId}/headers?channel=${channel}`,
  GET_CALL_PLANNER_SUMMARY: (
    allocationId: string,
    groupId: string | null,
    channel: ChannelUppercase,
    isAllocated: boolean,
    ungrouped: boolean,
    searchValue: string
  ) =>
    `${phygitalURL}/allocation/api/v1/allocation-file/${allocationId}/summary?groupId=${groupId}&channel=${channel}&isAllocated=${isAllocated}&ungrouped=${ungrouped}&searchValue=${searchValue}&limit=10&offset=0`,
  GET_UNIQUE_VALUES_BY_COLUMN: (
    allocationId: string,
    channel: ChannelUppercase,
    columnName: string,
    groupId: string | null,
    isAllocated: boolean | null,
    ungrouped: boolean | null,
    limit: number,
    offset: number
  ) =>
    `${phygitalURL}/allocation/api/v1/allocation-file/${allocationId}/distinct?channel=${channel}&columnName=${columnName}&groupId=${groupId}&isAllocated=${isAllocated}&ungrouped=${ungrouped}&limit=${limit}&offset=${offset}`,
  SEARCH_IN_FILTER_BY_VALUES: (
    allocationId: string,
    isAllocated: boolean,
    ungrouped: boolean
  ) =>
    `${phygitalURL}/allocation/api/v1/allocation-file/${allocationId}/distinct/search?isAllocated=${isAllocated}&ungrouped=${ungrouped}`,
  SEARCH_IN_DATAGRID: (
    allocationId: string,
    channel: ChannelUppercase,
    value: string,
    groupId: string,
    isAllocated: boolean,
    ungrouped: boolean
  ) =>
    `${phygitalURL}/allocation/api/v1/allocation-file/${allocationId}/search?channel=${channel}&searchValue=${value}&groupId=${groupId}&isAllocated=${isAllocated}&ungrouped=${ungrouped}`,
  GET_CALL_FIELD_PLANNER_METRICS: (
    agencyId: string,
    allocationId: string,
    channel: ChannelUppercase
  ) =>
    `${phygitalURL}/allocation/api/v1/allocation-file/ucf-planner-summary?agencyId=${agencyId}&allocationId=${allocationId}&channel=${channel}`,
  GET_CAMPAIGNS: (agencyId: string) =>
    `${phygitalURL}/api/v1/campaigns?agency_id=${agencyId}`,
  GET_AGENTS_IN_AND_OUT_OF_CAMPAIGN: () =>
    `${phygitalURL}/api/v1/campaigns/agents`,
  CREATE_BORROWER_GROUP: (ungrouped: boolean, isAllocated: boolean) =>
    `${phygitalURL}/api/v1/borrower-group?ungrouped=${ungrouped}&isAllocated=${isAllocated}`,
  GET_BORROWER_GROUPS: (allocationFileId: string, supervisorId: string) =>
    `${phygitalURL}/api/v1/borrower-groups?allocationFileId=${allocationFileId}&supervisorId=${supervisorId}`,
  // GET_BORROWERS_IN_GROUP: (groupId: string) =>
  //   `${phygitalURL}/api/v1/borrower-group/${groupId}`,
  GET_CAMPAIGN_ALLOCATION_SUMMARY: (agencyId: string) =>
    `${phygitalURL}/api/v1/campaigns/summary?agencyId=${agencyId}`,
  FETCH_AGENTS_BY_CAMPAIGN: () =>
    `${phygitalURL}/api/v1/campaigns/agents/by-campaign`,
  UNASSIGN_CAMPAIGN_BORROWER_GROUP: (groupId: string, allocationId: string) =>
    `${phygitalURL}/api/v1/borrower-group/${groupId}/unassign-campaigns?allocationId=${allocationId}`,
  REASSIGN_CAMPAIGN_BORROWER_GROUP: (groupId: string) =>
    `${phygitalURL}/api/v1/borrower-group/${groupId}/reassign-campaigns`,
  // SAVE_LAST_SELECTED_GROUP: () =>
  //   `${phygitalURL}/api/v1/agent/save-last-selected-borrower-group`,
  GROUP_OPERATIONS_SSE: (
    agencyId: string,
    allocatorId: string,
    userId: string
  ) =>
    `${SSE_BASE_URL}/group-operations?agencyId=${agencyId}&allocatorId=${allocatorId}&userId=${userId}`,
  FETCH_BORROWER_STATS: (campaignId: string) =>
    `${phygitalURL}/api/v1/campaigns/${campaignId}/borrower-stats`,
};
const fieldPlannerEndPoints = {
  AUTO_ASSIGN_AGENTS: (allocationId: string) =>
    `${phygitalURL}/auto-assign-agent/${allocationId}`,
  MANUAL_FIELD_AGENT_ASSIGN: (ungrouped: boolean, isAllocated: boolean) =>
    `${phygitalURL}/assign-field-agent?ungrouped=${ungrouped}&isAllocated=${isAllocated}`,
  REASSIGN_FIELD_AGENT_ASSIGN: (ungrouped: boolean, isAllocated: boolean) =>
    `${phygitalURL}/reassign-field-agent?ungrouped=${ungrouped}&isAllocated=${isAllocated}`,
  UNASSIGN_FIELD_AGENT: (ungrouped: boolean, isAllocated: boolean) =>
    `${phygitalURL}/unassign-field-agent?ungrouped=${ungrouped}&isAllocated=${isAllocated}`,
  GET_AGENTS: (channel: ChannelUppercase, supervisorId: string) =>
    `${phygitalURL}/api/v1/agents?supervisor_id=${supervisorId}&channel=${channel}`,
  SCHEDULE_VISIT: (ungrouped: boolean, isAllocated: boolean) =>
    `${phygitalURL}/allocation/schedule-field-agent?ungrouped=${ungrouped}&isAllocated=${isAllocated}`,
};

const advancedPlannerEndPoints = {
  GET_GROUPS: (allocationId: string) =>
    `${advancePlannerURL}/groups?allocationId=${allocationId}`,
  GET_GROUP: (groupId: string | number) =>
    `${advancePlannerURL}/groups?group?groupId=${groupId}`,
  CREATE_GROUP: () => `${advancePlannerURL}/group`,
  EDIT_GROUP: (groupId: string | number) =>
    `${advancePlannerURL}/group?groupId=${groupId}`,
  DELETE_GROUP: (groupId: string | number) =>
    `${advancePlannerURL}/group?groupId=${groupId}`,
};
const crmEndPoints = {
  FETCH_CAMPAIGNS_BY_AGENT: (agentId: string) =>
    `${phygitalURL}/crm/api/v1/campaigns?agentId=${agentId}`,
  SAVE_CAMPAIGN: ({
    taskType,
    count,
  }: {
    taskType?: TaskType;
    count?: number;
  }) => {
    if (taskType !== undefined && count !== undefined) {
      return `${phygitalURL}/crm/api/v1/agent/save-campaign?taskType=${taskType}&count=${count}`;
    }
    return `${phygitalURL}/crm/api/v1/agent/save-campaign`;
  },
  FETCH_BORROWERS_IN_CURRENT_CAMPAIGN: (
    agentId: string,
    campaignId: string,
    limit = 10,
    offset = 0
  ) =>
    `${phygitalURL}/crm/api/v1/borrowers?agentId=${agentId}&campaignId=${campaignId}&limit=${limit}&offset=${offset}`,
  FETCH_SEARCHED_BORROWERS_IN_CURRENT_CAMPAIGN: (
    agentId: string,
    campaignId: string,
    limit = 10,
    offset = 0,
    searchValue = ''
  ) =>
    `${phygitalURL}/crm/api/v1/borrowers/search?agentId=${agentId}&campaignId=${campaignId}&limit=${limit}&offset=${offset}&searchValue=${searchValue}`,
  CLICK_TO_CALL: () => `${phygitalURL}/crm/api/v1/click-to-call`,
  FETCH_BORROWER_INFO: (borrowerId: string, pin?: string) =>
    `${phygitalURL}/crm/api/v1/borrowers/${borrowerId}?pin=${pin}`,
  FETCH_AGENT_INFO: (agentId: string) =>
    `${phygitalURL}/crm/api/v1/agent-info?agentId=${agentId}`,

  FETCH_BEST_AND_LAST_DISPOSITION: (agencyId: string, borrowerId: string) =>
    `${ucfURL}/dispositions/best-and-latest-dispositions?agencyId=${agencyId}&borrowerId=${borrowerId}`,

  ADD_DISPOSITION: () => `${phygitalURL}/crm/dispose-call-order`,
  FETCH_DISPOSITIONS: () => `${phygitalURL}/crm/dispositions?channel=CALL`,
  // FETCH_DISPOSITIONS: () => `${ucfURL}/api/mobile/agent/disposition/all`,
  DISPOSITION_WISE_SUMMARY: (
    agentId: string,
    campaignId: string,
    limit = 10,
    offset = 0
  ) =>
    `${phygitalURL}/crm/api/v1/disposition-wise-summary?agentId=${agentId}&campaignId=${campaignId}&limit=${limit}&offset=${offset}`,
  INTERACTION_HISTORY: (limit: number, offset: number) =>
    `${phygitalURL}/crm/activity-history?limit=${limit}&offset=${offset}`,
  GET_BORROWER_ID: (encryptedPhoneNumber: string, campaignId: string) =>
    `${phygitalURL}/crm/api/v1/get-borrower-id?phoneNumber=${encryptedPhoneNumber}&campaignId=${campaignId}`,
  GET_FOLLOW_UP_TIME_RANGES: (agentId: string, campaignId: string) =>
    `${phygitalURL}/crm/api/v1/time-ranges/callback?agentId=${agentId}&campaignId=${campaignId}`,
  GET_FOLLOW_UP_CURRENT_TIME: () =>
    `${phygitalURL}/crm/api/v1/time-ranges/current`,
  GET_UNIQUE_VALUES_BY_COLUMN: (
    agentId: string,
    campaignId: string,
    columnName: string,
    limit: number,
    offset: number
  ) =>
    `${phygitalURL}/crm/api/v1/borrowers/distinct?agentId=${agentId}&campaignId=${campaignId}&columnName=${columnName}&limit=${limit}&offset=${offset}`,
  SEARCH_IN_FILTER_BY_VALUES: (allocationId: string) =>
    `${phygitalURL}/crm/api/v1/distinct/search?allocationId=${allocationId}`,
  SEND_TUBELIGHT_EVENTS: `${YUBI_GATEWAY_URL}/ucf-service/ucf/api/v1/tube-call-events`,

  // Alternate number
  ADD_ALTERNATE_NUMBER: () =>
    `${phygitalURL}/crm/api/v1/borrower/alternate-mobile`,
  UPDATE_ALTERNATE_NUMBER: () =>
    `${phygitalURL}/crm/api/v1/borrower/alternate-mobile`,

  // Remark templates
  GET_REMARK_TEMPLATES: (subDispositionId: string) =>
    `${ucfURL}/ucf/api/v1/templates/sub-disposition/${subDispositionId}?channel=call`,
  // Missed calls
  FETCH_MISSED_CALLS: () => `${ucfURL}/ucf/telephony/api/v1/missed-call-logs`,
  FETCH_MISSED_CALLS_DISTINCT: (columnName: string) =>
    `${ucfURL}/ucf/telephony/api/v1/missed-call-logs/distinct?columnName=${columnName}`,
  // Priority Tasks
  FETCH_PRIORITY_TASKS: () => `${phygitalURL}/api/v1/priority-tasks`,
  FETCH_PRIORITY_TASKS_SUMMARY: () =>
    `${phygitalURL}/api/v1/priority-tasks/summary`,
  FETCH_PRIORITY_TASKS_DISTINCT: () =>
    `${phygitalURL}/api/v1/priority-tasks/distinct`,
  FETCH_ADDITIONAL_DETAILS: (
    allocationRecordId: string,
    allocationId: string
  ) =>
    `${plannerURL}/data?allocationRecordId=${allocationRecordId}&allocationId=${allocationId}`,
  GET_CAMPAIGN_LIVE_EVENTS: (campaignId: string) =>
    `${ucfURL}/ucf/api/v1/sse/campaign/${campaignId}/stats`,
  BARGING_API: (email: string) =>
    `${phygitalURL}/crm/api/v1/barge-call/${email}`,

  // Agent ping monitoring
  // SEND_AGENT_PING_BATCH: `${ihsURL}/api/v1/agent-activity/publish`,
  FETCH_OTHER_LOANS: (borrowerId: string, pin: string) =>
    `${phygitalURL}/crm/api/v1/borrower/${borrowerId}/other-loans?pin=${pin}`,
  FETCH_PREVIOUS_OR_NEXT_BORROWER: (
    borrowerId: string,
    direction: 'previous' | 'next',
    agentId: string,
    campaignId: string,
    limit = 1
  ) =>
    `${phygitalURL}/crm/api/v1/borrower/${borrowerId}/${direction}?agentId=${agentId}&campaignId=${campaignId}&limit=${limit}`,
};

const supervisorCRMEndPoints = {
  FETCH_BORROWERS_IN_CURRENT_CAMPAIGN: (
    agentId: string,
    campaignId: string,
    limit = 10,
    offset = 0,
    taskType: TaskType = TASK_TYPES.ALL_TASK
  ) =>
    `${phygitalURL}/crm/api/v1/borrowers?agentId=${agentId}&campaignId=${campaignId}&limit=${limit}&offset=${offset}&taskType=${taskType}`,
  FETCH_SEARCHED_BORROWERS_IN_CURRENT_CAMPAIGN: (
    agentId: string,
    campaignId: string,
    limit = 10,
    offset = 0,
    searchValue = '',
    taskType: TaskType = TASK_TYPES.ALL_TASK
  ) =>
    `${phygitalURL}/crm/api/v1/borrowers/search?agentId=${agentId}&campaignId=${campaignId}&limit=${limit}&offset=${offset}&taskType=${taskType}&searchValue=${searchValue}`,
  FETCH_DISPOSITION_WISE_SUMMARY: (
    agentId: string,
    campaignId: string,
    limit = 10,
    offset = 0,
    taskType: TaskType = TASK_TYPES.ALL_TASK
  ) =>
    `${phygitalURL}/crm/api/v1/disposition-wise-summary?agentId=${agentId}&campaignId=${campaignId}&limit=${limit}&offset=${offset}&taskType=${taskType}`,
};

const agentEndpoints = {
  GET_AGENT_DETAILS: () => `${emsURL}/api/v1/agents`,
  // Agent onboarding
  BULK_UPLOAD_AGENT: `${emsURL}/ems/api/v1/users/bulk-upload`,
  SINGLE_UPLOAD_AGENT: `${emsURL}/ems/api/v1/users/single-upload`,
  GET_SUPERVISORS_BY_AGENCY: `${emsURL}/ems/api/v1/supervisors`,
  GET_CITIES: (size: number, search: string) =>
    `${discoveryNoAuthURL}/cities?size=${size}${
      search ? `&search=${search}` : ''
    }`,
  AREAS_BASED_ON_CITY: (city: string) =>
    `${discoveryURL}/city/areas?city=${city}`,
  PINCODES_BASED_ON_AREA: (area: string) =>
    `${discoveryURL}/area/pincodes?area=${area}`,

  OFFBOARD_AGENT: (yucollectEmployeeId: string) =>
    `${emsURL}/ems/api/v1/users/${yucollectEmployeeId}`,
  // View agent
  GET_AGENT_DETAILS_BY_ID: (agentId: string) =>
    `${emsURL}/ems/api/v1/users/${agentId}/details`,
  EDIT_AGENT: (agentId: string) => `${emsURL}/ems/api/v1/users/${agentId}/edit`,
};

const agentGroupEndpoints = {
  SAVE_GROUP: () => `${phygitalURL}/api/v1/agent-group`,
  VIEW_GROUPS: (supervisorId: string) =>
    `${phygitalURL}/api/v1/agent-groups/${supervisorId}`,
  GET_AGENT_COUNT: () => `${phygitalURL}/api/v1/agent-groups/count`,
};

const agentListEndpoints = {
  GET_AGENT_DETAILS_LIST: () => `${phygitalURL}/api/v2/agents`,
  GET_AGENT_DETAILS_LIST_SEARCH: () => `${phygitalURL}/api/v2/agents/search`,
  GET_AGENT_DETAILS_LIST_DISTINCT: (field: string, channel?: string | null) => {
    if (channel !== null && channel !== undefined && channel !== '') {
      return `${phygitalURL}/api/v2/agents/distinct?column=${field}&channel=${channel}`;
    } else {
      return `${phygitalURL}/api/v2/agents/distinct?column=${field}`;
    }
  },
  GET_AGENT_DETAILS_LIST_SUMMARY: (channel: string) =>
    `${phygitalURL}/api/v1/agent-summary?channel=${channel}`,
  GET_AGENT_DETAILS_LIST_COUNT: () => `${phygitalURL}/api/v2/agents/count`,
};

const callCampaignEndpoints = {
  VIEW_CAMPAIGNS: () => `${phygitalURL}/api/v1/campaigns`,
};

const campaignEndpoints = {
  CREATE_CAMPAIGN: () => `${phygitalURL}/api/v1/campaigns/create`,
  GET_CAMPAIGN_SUMMARY: `${phygitalURL}/api/v1/campaigns/top-summary`,
  GET_ALL_CAMPAIGN: (limit: number, offset: number, searchValue = '') =>
    `${phygitalURL}/api/v2/campaigns/list?limit=${limit}&offset=${offset}&searchValue=${searchValue}`,
  START_CAMPAIGN: (campaignId: string) =>
    `${phygitalURL}/api/v1/campaigns/${campaignId}/start-campaign`,
  PAUSE_CAMPAIGN: (campaignId: string) =>
    `${phygitalURL}/api/v1/campaigns/${campaignId}/pause-campaign`,
  VIEW_CAMPAIGN: (campaignId: string) =>
    `${phygitalURL}/api/v1/campaigns/${campaignId}`,
  UPDATE_CAMPAIGN: (campaignId: string) =>
    `${phygitalURL}/api/v1/campaigns/${campaignId}`,
  GET_DISPOSITION_LIST_BY_CAMPAIGN_ID: (campaignId: string) =>
    `${phygitalURL}/api/v1/churn-analytics/${campaignId}`,
  CHURN_ANALYTICS: (campaignId: string) =>
    `${phygitalURL}/api/v1/churn-analytics/${campaignId}`,
  GET_DISPOSITION_LIST: () => `${ucfURL}/dispositions/autochurn`,
};

const settingsEndpoints = {
  /* Location, Channel, Product, Bucket, Payment preferences end point */
  GET_PREFERENCES: (
    preferenceType: string,
    offset = 0,
    limit = 10,
    searchCriteria = ''
  ) =>
    `${epsBaseUrl}/config/api/v1/${preferenceType}?offset=${offset}&limit=${limit}&query=${searchCriteria}`,
  ENABLE_OR_DISABLE_PREFERENCES: (
    preferenceType: string,
    preferenceId: number,
    isEnabled: boolean
  ) =>
    `${epsBaseUrl}/config/api/v1/${preferenceType}/${preferenceId}?enabled=${isEnabled}`,
  CREATE_CHANNEL_PREFERENCES: `${epsBaseUrl}/config/api/v1/channels`,
  UPLOAD_LOCATION_PREFERENCES: `${epsBaseUrl}/config/api/v1/locations`,
  PAYMENT_CONFIG: `${epsBaseUrl}/config/api/v1/payment-config`,
  PAYMENT_GATEWAY_CONFIG: `${epsBaseUrl}/config/api/v1/payment-gateway-config`,
  GET_CONTENT_PREFERENCE: `${epsBaseUrl}/config/api/v1/content-preference`,

  // Onboarding endpoint
  GET_ENTITY_DETAILS: `${emsURL}/ems/api/v1/entity/onboard`,
  GET_AGENCY_ONBOARD_URL: `${emsURL}/ems/api/v1/agency/onboard`,

  // LMS fields endpoint
  LMS_FIELDS: `${epsBaseUrl}/config/api/v1/lms-fields`,
  GET_DERIVED_FIELDS: `${epsBaseUrl}/config/api/v1/derived-fields`,
  DELETE_DERIVED_FIELD: `${epsBaseUrl}/config/api/v1/derived-fields`,
  // CREATE_DERIVED_FIELD: `${epsBaseUrl}/config/api/v1/derived-fields`,
  CREATE_DERIVED_FIELD: `${ingestionURL}/derived-fields`,
  GET_DERIVED_FIELDS_BY_AGENCY: (agencyId: string, allocatorId: string) =>
    `${ingestionURL}/derived-fields?allocatorId=${allocatorId}&agencyId=${agencyId}`,
  UPDATE_LMS_FIELDS: `${epsBaseUrl}/config/api/v1/lms-fields`,
  UPDATE_DERIVED_FIELDS: `${epsBaseUrl}/config/api/v1/derived-fields`,

  // Compliance endpoint
  Get_GLOBAL_POLICIES: `${hostName}/collections/compliance/v1/config/global`,
  GET_DEFAULT_POLICIES: `${hostName}/collections/compliance/v1/config/lender/default`,
  GET_ALL_POLICIES: `${hostName}/collections/compliance/v1/config/lender/policy/all`,
  SAVE_DEFAULT_POLICIES: (isSave: boolean) =>
    `${hostName}/collections/compliance/v1/config/lender/default/${
      isSave ? 'create' : 'update'
    }`,
  SAVE_LENDER_POLICY: (isEdit: boolean) =>
    `${hostName}/collections/compliance/v1/config/lender/policy/${
      isEdit ? 'update' : 'create'
    }`,
  UPDATE_POLICY_STATUS: `${hostName}/collections/compliance/v1/config/lender/policy/update/status`,
  GET_LOB_POLICIES: `${hostName}/collections/compliance/v1/config/plan`,
};

const allocator = {
  GET_ALLOCATOR_LIST: (vendorId: string) =>
    `${discoveryURL}/agencies/${vendorId}/allocator-list`,
  GET_PENDING_ALLOCATOR_LIST: (vendorId: string) =>
    `${discoveryURL}/agencies/${vendorId}/pending-allocator-list`,
  GET_REJECTED_ALLOCATOR_LIST: (vendorId: string) =>
    `${discoveryURL}/agencies/${vendorId}/rejected-allocator-list`,
  GET_ALLOCATOR_REQUIREMENTS: (agencyId: string, allocatorId: string) =>
    `${discoveryURL}/agency/${agencyId}/allocator/${allocatorId}/requirements`,
  GET_LENDER_INVITES: `${emsURL}/ems/api/v1/agency/association/lender/invites`,
  GET_LENDERS: `${emsURL}/ems/api/v1/agency/association/lenders/my-lender`,
  ACCEPT_INVITES: `${emsURL}/ems/api/v1/agency/association/lender/invites/accept`,
  REJECT_INVITES: `${emsURL}/ems/api/v1/agency/association/lender/invites/reject`,
  GET_UNIQUE_LENDERS: `${emsURL}/ems/api/v1/user/entities/association/allocators/all`,
};

const campaignPlanner = {
  // START Yucollect Endpoints
  // GET_CAMPAIGN_SUMMARY: (lenderId: string) =>
  //   `${campaignUrl}/collections/api/v1/campaign-planner/fetchCampaignSummary/${lenderId}`,
  GET_CAMPAIGN_SUMMARY: (limit: number, offset: number) =>
    `${plannerURLForDigital}/list?limit=${limit}&offset=${offset}`,
  // ASSIGN_CAMPAIGN_SUMMARY: `${campaignUrl}/collections/api/v1/campaign-planner/confirmAssignment`,
  ASSIGN_CAMPAIGN_SUMMARY: () => `${plannerURLForDigital}/start-campaign`,
  // GET_CAMPAIGN_RECORD_DATA: (summaryId: string) =>
  //   `${campaignUrl}/collections/api/v1/campaign-planner/fetchDigitalCampaignData/${summaryId}`,
  GET_CAMPAIGN_RECORD_DATA: (summaryId: string) =>
    `${plannerURLForDigital}/list/${summaryId}`,
  // END Yucollect Endpoints
  OUTREACH: (pagination?: { offset: number; limit: number }) =>
    pagination
      ? `${campaignURL}/collections/api/v1/campaign-planner/outreaches?pageNo=${pagination.offset}&recordsPerPage=${pagination.limit}`
      : `${campaignURL}/collections/api/v1/campaign-planner/outreaches`,
  GET_CONFIG: (lenderId: string) =>
    `${campaignURL}/collections/api/v1/campaign-planner/getConfig?lenderId=${lenderId}`,
  GET_CONTENT: (channel: string, language: string, lenderId: string) =>
    `${campaignURL}/collections/api/v1/campaign-planner/getContent/${channel}/${language}?lenderId=${lenderId}`,
  GET_CONDITION: `${campaignURL}/collections/api/v1/campaign-planner/condition`,
  GET_COMPLIANCE_POLICIES: `${campaignURL}/compliance/compliance-policies/by-name`,
  CREATE_CAMPAIGN: `${campaignURL}/collections/api/v1/campaign-planner/campaigns`,
  UPDATE_CAMPAIGN: (
    campaignId: string,
    lenderId: string,
    submitPlan: boolean
  ) =>
    `${campaignURL}/collections/api/v1/campaign-planner/campaigns/editCampaign/${campaignId}?lenderId=${lenderId}&submitPlan=${submitPlan}`,
  GET_CAMPAIGN_LIST: (
    name: string,
    status: string,
    pagination?: { offset: number; limit: number }
  ) =>
    pagination
      ? `${campaignURL}/collections/api/v1/campaign-planner/campaigns/fetchAllCampaigns/${status}?pageNo=${pagination.offset}&recordsPerPage=${pagination.limit}&name=${name}`
      : `${campaignURL}/collections/api/v1/campaign-planner/campaigns/fetchAllCampaigns/${status}?name=${name}`,
  GET_ALLOCATION_LIST: (lenderId: string, status: string, name: string) =>
    `${campaignURL}/collections/api/v1/campaign-planner/getAllocationList?lenderId=${lenderId}&status=${status}&name=${name}`,
  DELETE_STRATEGY: (strategyId: number) =>
    `${campaignURL}/collections/api/v1/campaign-planner/strategy/${strategyId}`,
  CREATE_STRATEGY: `${campaignURL}/collections/api/v1/campaign-planner/strategy`,
  DRAFT_SAVE_CAMPAIGN_PLAN: (campaignId: number) =>
    `${campaignURL}/collections/api/v1/campaign-planner/campaigns/saveDraft/${campaignId}`,
  PLAN_CAMPAIGN_PLAN: (lenderId: string) =>
    `${campaignURL}/collections/api/v1/campaign-planner/submitPlan?lenderId=${lenderId}`,
  FETCH_SEGMENTS_LIST: (allocationId: number) =>
    `${campaignURL}/collections/segments/${allocationId}`,
  FETCH_CAMPAIGN_PLAN: (allocationId: number) =>
    `${campaignURL}/collections/api/v1/campaign-planner/campaigns/${allocationId}`,
  FETCH_STRATEGY_LIST: (pagination?: {
    offset: number;
    limit: number;
    searchText: string;
  }) =>
    pagination
      ? `${campaignURL}/collections/api/v1/campaign-planner/strategy/fetchStrategyList?pageNo=${pagination.offset}&recordsPerPage=${pagination.limit}&searchText=${pagination.searchText}`
      : `${campaignURL}/collections/api/v1/campaign-planner/strategy/fetchStrategyList`,
  FETCH_STRATEGY_DETAILS: (strategyId: string) =>
    `${campaignURL}/collections/api/v1/campaign-planner/strategy/${strategyId}`,
  POST_STRATEGY: `${hostName}/collections/api/v1/campaign-planner/strategy`,
  UPDATE_STRATEGY: (strategyId: string) =>
    `${campaignURL}/collections/api/v1/campaign-planner/strategy/${strategyId}`,
  POST_SEGMENTS_LIST: (campaignId: string) =>
    `${campaignURL}/collections/api/v1/campaign-planner/campaigns/segments/${campaignId}`,
  CLONE_STRATEGY: (strategyId: number) =>
    `${campaignURL}/collections/api/v1/campaign-planner/strategy/clone/${strategyId}`,
  FETCH_OUTREACH_LIST: (
    name: string,
    pagination?: { offset: number; limit: number }
  ) =>
    pagination
      ? `${campaignURL}/collections/api/v1/campaign-planner/outreaches/fetchOutreachList?name=${name}&pageNo=${pagination.offset}&recordsPerPage=${pagination.limit}`
      : `${campaignURL}/collections/api/v1/campaign-planner/outreaches/fetchOutreachList?name=${name}`,
  GET_OUTREACH_FILTERS: `${campaignURL}/collections/api/v1/campaign-planner/outreaches/getOutreachFilters`,
  STRATEGY_LIST_FILTER_API: `${campaignURL}/collections/api/v1/campaign-planner/strategy/fetchStrategyFilter`,
  CREATE_BULK_OUTREACH: `${campaignURL}/collections/api/v1/campaign-planner/bulk-outreaches`,
  PAUSE_CAMPAIGN: (campaignId: number, status: string) =>
    `${campaignURL}/collections/api/v1/campaign-planner/pauseOrActivatePlan/${campaignId}?status=${status}`,
  ROLL_BACK_CAMPAIGN: (campaignId: string) =>
    `${campaignURL}/collections/api/v1/campaign-planner/campaigns/${campaignId}/rollBackCampaign`,
  RAISE_NBA_FAILURE_TICKET: `${campaignURL}/collections/api/v1/campaign-planner/campaigns/raiseNBAFailureTicket`,
  DOWNLOAD_NBA_PLAN: (campaignId: string) =>
    `${campaignURL}/collections/api/yc/v1/campaign-planner/campaigns/${campaignId}/download-nba-plan`,
};

const hierarchyManagementEndPoint = {
  designationEndpoint: {
    ADD_DESIGNATION: `${epsBaseUrl}/api/v1/designations`,
    DELETE_DESIGNATION: (designationId: string) =>
      `${epsBaseUrl}/api/v1/designations/${designationId}`,
    UPDATE_DESIGNATION: (designationId: string) =>
      `${epsBaseUrl}/api/v1/designations/${designationId}`,
    GET_DESIGNATION_LIST: (offset = 0, limit = 10, searchKeyword = '') =>
      `${epsBaseUrl}/api/v1/designations?limit=${limit}&offset=${offset}&searchKeyword=${searchKeyword}`,
    ADD_DESIGNATION_BY_FILE: `${epsBaseUrl}/api/v1/designations/file-upload`,
  },
  hierarchySetupEndpoint: {
    GET_REPORTING_HIERARCHY: (caUserId: string) =>
      `${epsBaseUrl}/api/v1/hierarchy/${caUserId}`,
    ADD_HIERARCHY_DETAILS: ({
      isRootUser,
      userId,
    }: {
      isRootUser: boolean;
      userId: string;
    }) => `${epsBaseUrl}/api/v1/hierarchy/${userId}?isRootUser=${isRootUser}`,
    GET_TEAM_MEMBERS: (
      filterQueryString: string,
      offset = 0,
      limit = 10,
      searchKeyword = ''
    ) => {
      if (filterQueryString) {
        return `${epsBaseUrl}/api/v1/hierarchy/team-members?limit=${limit}&offset=${offset}&${filterQueryString}&searchKeyword=${searchKeyword}`;
      }

      return `${epsBaseUrl}/api/v1/hierarchy/team-members?limit=${limit}&offset=${offset}&searchKeyword=${searchKeyword}`;
    },
  },
  GET_PRODUCT_BUCKET_LOCATION: (caUserId: string) =>
    `${epsBaseUrl}/api/v1/user-configuration/${caUserId}`,
  GET_PRODUCT_BUCKET_LIST: `${epsBaseUrl}/config/api/v1/products/product-bucket-list`,
  SET_PRODUCT_BUCKET: `${epsBaseUrl}/api/v1/user-configuration`,
  UPLOAD_USER_BY_FILE: `${epsBaseUrl}/api/v1/hierarchy/file-upload`,
  SEARCH_DESIGNATION: (searchCriteria: string) =>
    `${epsBaseUrl}/api/v1/designations/search?keyword=${searchCriteria}`,
};

const locationManagementEndPoint = {
  getLocations: (locationType: string, state?: string) =>
    state
      ? `${epsBaseUrl}/config/api/v1/${locationType}/locations?state=${state}`
      : `${epsBaseUrl}/config/api/v1/${locationType}/locations`,
  GET_LOCATION_TYPE: `${epsBaseUrl}/config/api/v1/locations/location-types`,
};

const segmentsEndPoints = {
  SET_SEGMENT_LIST: `${hostName}/collections/api/v1/campaign-planner/segments`,
  CREATE_SEGMENT: `${hostName}/collections/api/v1/campaign-planner/segments`,
  UPDATE_SEGMENT: (segmentId: string) =>
    segmentId
      ? `${hostName}/collections/api/v1/campaign-planner/segments/${segmentId}`
      : `${hostName}/collections/api/v1/campaign-planner/segments`,
  GET_SEGMENTS_LIST: (offset = 0, limit = 10) =>
    `${hostName}/collections/api/v1/campaign-planner/segments?pageNo=${offset}&recordsPerPage=${limit}`,
  GET_SEGMENT: (segmentId: string) =>
    `${hostName}/collections/api/v1/campaign-planner/segments/${segmentId}`,
  DELETE_SEGMENT: (segmentId: string) =>
    `${hostName}/collections/api/v1/campaign-planner/segments/${segmentId}`,
};

const campaignEndPoints = {
  CREATE_SEGMENT: (campaignId: string, submitPlan: boolean, lenderId: string) =>
    `${campaignURL}/collections/api/v1/campaign-planner/campaigns/segments/${campaignId}?submitPlan=${submitPlan}&lenderId=${lenderId}`,
  START_CAMPAIGN: (campaignId: string) =>
    `${orchestratorURL}/collections/api/v1/campaign-orchestrator/start-campaign/${campaignId}`,
  // STOP_CAMPAIGN: (campaignId: string) =>
  //   `${campaignURL}/collections/api/v1/campaign-planner/terminate-campaign/${campaignId}`,
  STOP_CAMPAIGN: `${plannerURLForDigital}/terminate-campaign`,
};

const contentManagement = {
  POST_TEMPLATE_CREATION: (channel: string) =>
    `${contentManagementBaseURL}/cms/v1/api/${channel}`,
  POST_TEST_TEMPLATE: `${contentManagementBaseURL}/cms/v1/api/content/test`,
  POST_CONTENT_LIST: (contentType: string, pageNo: number, pageSize: number) =>
    `${contentManagementBaseURL}/cms/v1/api/${contentType}/filter?pageSize=${pageSize}&pageNumber=${pageNo}`,
  DELETE_CONTENT: (channel: string) =>
    `${contentManagementBaseURL}/cms/v1/api/${channel}/delete`,
  FETCH_CONTENT_TEMPLATE_DETAILS: (channel: string) =>
    `${contentManagementBaseURL}/cms/v1/api/${channel}/templateDetails`,
  DELETE_CONTENT_BY_ID: (channel: string, id: number) =>
    `${contentManagementBaseURL}/cms/v1/api/${channel}/${id}`,
  FETCH_CONFIG: `${contentManagementBaseURL}/cms/v1/api/config`,
  POST_CLONE_TEMPLATE: (channel: string) =>
    `${contentManagementBaseURL}/cms/v1/api/${channel}/clone`,
};

type CampaignOutreachDroppedMetrics = {
  nodeId: string;
  segmentId: number;
};

type CampaignSegmentIdType = {
  campaignId: number;
  segmentId?: number;
};
const campaignMetrics = {
  GET_CAMPAIGN_OUTREACH_METRICS: ({ campaignId }: { campaignId: string }) =>
    `${hostName}/collections/api/v1/sentinel/metrics/campaign/${campaignId}/outreach?pageNumber=1&pageSize=10`,
  GET_OUTREACH_DROPPED_DETAILS: ({
    nodeId,
    segmentId,
  }: CampaignOutreachDroppedMetrics) =>
    `${hostName}/collections/api/v1/sentinel/metrics/campaign/70840/outreach/dropped/${nodeId}?segmentId=${segmentId}`,
  GET_CAMPAIGN_EVENTS_SUMMARY: ({
    campaignId,
    segmentId,
  }: CampaignSegmentIdType) =>
    `${hostName}/collections/api/v1/sentinel/metrics/campaign/${campaignId}/summary${
      segmentId ? `?segmentId=${segmentId}` : ''
    }`,
  GET_CAMPAIGN_SEGMENTS: ({ campaignId }: { campaignId: string }) =>
    `${hostName}/collections/api/v1/campaign-planner/campaigns/${campaignId}/segment-details`,
  GET_DISPOSITION_LIST: ({
    campaignId,
    segmentId,
    offset,
    limit,
  }: {
    offset: number;
    limit: number;
  } & CampaignSegmentIdType) =>
    `${hostName}/collections/api/v1/sentinel/metrics/campaign/${campaignId}/dispositions?pageNumber=${offset}&pageSize=${limit}${
      segmentId ? `&segmentId=${segmentId}` : ''
    }`,

  GET_CAMPAIGN_DETAILS_BY_ID: (campaignId: string) =>
    `${hostName}/collections/api/v1/campaign-planner/campaigns/${campaignId}/campaign-summary`,
};

const agencyOnboarding = {
  SEND_OTP: `${emsAgencyOnBoardingNoAuthURL}/send`,
  SEND_SIGNIN_OTP: `${emsAgencyOnBoardingNoAuthURL}/send/sign-in`,
  VERIFY_OTP: `${emsAgencyOnBoardingNoAuthURL}/verify`,
  REGISTER_COMPANY: `${emsAgencyOnBoardingNoAuthURL}/agency/register-company`,
  UPDATE_TEMP_AGENCY: `${emsAgencyOnBoardingNoAuthURL}/agency/update-temp-agency`,
  GET_AGENCY_BY_ID: (agencyId: string) =>
    `${emsAgencyOnBoardingNoAuthURL}/agency/${agencyId}`,
  GET_AGENCY_DOCUMENTS_SUMMARY: (agencyId: string) =>
    `${emsAgencyOnBoardingNoAuthURL}/agency/${agencyId}/documents/summary`,
  GET_AGENCY_ALLOCATORS: (agencyId: string) =>
    `${emsAgencyOnBoardingNoAuthURL}/agency/${agencyId}/allocators`,
  GET_AGENCY_AUTHORITIES: (agencyId: string) =>
    `${emsAgencyOnBoardingNoAuthURL}/agency/${agencyId}/authorities`,
  GET_ALL_ALLOCATORS: `${emsAgencyOnBoardingNoAuthURL}/allocators`,
  SEARCH_ALLOCATORS: (allocatorName: string) =>
    `${emsAgencyOnBoardingNoAuthURL}/get-allocators-list?allocatorName=${encodeURIComponent(
      allocatorName
    )}`,
  CREATE_ALLOCATOR: `${emsAgencyOnBoardingNoAuthURL}/allocator`,
  AGENCY_BASIC_DETAILS: `${emsAgencyOnBoardingNoAuthURL}/agency/basic-details`,
  AGENCY_OWNER_DETAILS: `${emsAgencyOnBoardingNoAuthURL}/agency/owner-client-details`,
  AGENCY_PRODUCT_BUCKET: `${emsAgencyOnBoardingNoAuthURL}/v2/agency/product-bucket`,
  GET_AGENCY_PRODUCT_BUCKET: (agencyId: string) =>
    `${emsAgencyOnBoardingNoAuthURL}/v2/agency/product-bucket/${agencyId}`,
  STORE_DOCUMENT: `${emsAgencyOnBoardingNoAuthURL}/entity-documents`,
  UPDATE_DOCUMENT: (id: string) =>
    `${emsAgencyOnBoardingNoAuthURL}/entity-documents/${id}`,
  GET_DOCUMENT_BY_ENTITY_ID: (entityId: string) =>
    `${emsAgencyOnBoardingNoAuthURL}/entity-documents/entity/${entityId}`,
  GET_DOCUMENT_COLUMN_MASTER: (queryString: string) =>
    `${emsAgencyOnBoardingNoAuthURL}/agency-document-master/search?${queryString}`,
  GET_AGENCY_COMPANY_NAME: (comapnyName: string, page = 0) => {
    if (comapnyName === '' || comapnyName === null) {
      return `${emsAgencyOnBoardingNoAuthURL}/get-agencies-list?page=${page}`;
    } else {
      return `${emsAgencyOnBoardingNoAuthURL}/get-agencies-list?agencyName=${comapnyName}&page=${page}`;
    }
  },
  GET_DETAILS_FROM_PINCODE: (pincode: string) =>
    `${emsAgencyOnBoardingNoAuthURL}/pincode-master/details?pincode=${pincode}`,
  GET_PRESIGNED_URL: (objectKey: string) =>
    `${emsAgencyOnBoardingNoAuthURL}/generate-presigned-url?objectKey=${objectKey}`,
  ACTIVATE_AGENCY_ON_PLATFORM: (agencyId: string) =>
    `${emsAgencyOnBoardingURL}/agency/platform-onboarding?agencyId=${agencyId}`,
  GET_ALLOCATOR_AGENCIES: (allocatorId: string) =>
    `${discoveryURL}/agency/allocator/${allocatorId}/get-agencies`,
  GET_ALLOCATORS: `${emsURL}/ems/api/v1/agency/association/lenders/my-lender`,
  GET_AGENT_ONBOARDING: `${emsURL}/ems/api/v1/agents/onboard`,
  GET_ALLOCATOR_VENDOR_CODE: (allocatorId: string) =>
    `${discoveryURL}/allocators/${allocatorId}/vendor-code`,
};

const yucollectAdmin = {
  GET_ALL_AGENCIES: `${discoveryURL}/agency-list`,
  GET_DISCOVERY_ALLOCATORS: `${discoveryURL}/allocators`,
  DOWNLOAD_AGENCY_EXCEL: `${discoveryURL}/agency/export`,
  APPROVE_DOCUMENT: (id: string) =>
    `${emsAgencyOnBoardingURL}/entity-documents/${id}/approve`,
  REJECT_DOCUMENT: (id: string) =>
    `${emsAgencyOnBoardingURL}/entity-documents/${id}/reject`,
  GET_UNIQUE_VALUES_BY_COLUMN: (name: string) =>
    `${discoveryURL}/agency-list/distinct?columnName=${name}`,
};

const agency = {
  ACCEPT_INTEREST: () => `${discoveryURL}/agency/allocator/accept`,
  REJECT_INTEREST: () => `${discoveryURL}/agency/allocator/reject`,
  ACTIVATE_AGENCY: () => `${discoveryURL}/agency/allocator/activate`,
};

const reportsEndPoints = {
  APPLY_FILTERS: `${reportsURL}/filters`,
  GET_REPORTS_BASE_URL: (allocatorId: string) => {
    return `${ingestionURL}/api/v1/allocators/${allocatorId}/allocations`;
  },
  DOWNLOAD_REPORT: (reportType: ReportType, channel: Channel) =>
    `${ihsURL}/api/v1/reports/${channel.toLowerCase()}?reportType=${reportType}`,
  REQUEST_CALL_REPORT: (reportType: ReportType) =>
    `${ihsURL}/api/v1/reports/request/call?reportType=${reportType}`,
  GET_CALL_REPORTS: () => `${ihsURL}/api/v1/reports/call/list`,
  DOWNLOAD_CALL_REPORT: (id: string) =>
    `${ihsURL}/api/v1/reports/download/${id}`,
  REQUEST_DIGITAL_REPORT: (reportType: ReportType) =>
    `${ihsURL}/api/v1/reports/request/digital?reportType=${reportType}`,
  GET_DIGITAL_REPORTS: () => `${ihsURL}/api/v1/reports/digital/list`,
  DOWNLOAD_DIGITAL_REPORT: (id: string) =>
    `${ihsURL}/api/v1/reports/download/${id}`,
  // Call Recording endpoints
  REQUEST_CALL_RECORDING: () => `${ihsURL}/api/v1/call-recordings/request`,
  GET_CALL_RECORDINGS: () => `${ihsURL}/api/v1/call-recordings/list`,
  DOWNLOAD_CALL_RECORDING: (id: string) =>
    `${ihsURL}/api/v1/call-recordings/download/${id}`,
  // WhatsApp Report endpoints
  GET_WHATSAPP_REPORTS: (page: number, size: number) => {
    const params = new URLSearchParams({
      page: String(page),
      size: String(size),
    });
    return `${ucfURL}/api/crm/whatsapp-reports?${params}`;
  },
  REQUEST_WHATSAPP_REPORT: () => `${ucfURL}/api/crm/whatsapp-reports`,
  DOWNLOAD_WHATSAPP_REPORT: (id: string) =>
    `${ucfURL}/api/crm/whatsapp-reports/${id}/download`,
};

const columnMappingEndPoints = {
  UPLOAD_COLUMN_MAPPING: () => `${ingestionURL}/column-mapping`,
  GET_MAPPING: (fileType: string) =>
    `${ingestionURL}/column-mapping?fileType=${fileType}`,
  GET_MAPPING_BY_ID: (id: string) => `${ingestionURL}/column-mapping/${id}`,
  UPDATE_MAPPING: (id: string) => `${ingestionURL}/column-mapping/${id}`,
  DELETE_MAPPING: (id: string) => `${ingestionURL}/column-mapping/${id}`,
  GET_COLUMN_MAPPING_BY_FILTER: () => `${ingestionURL}/column-mapping/filter`,
  MAP_ALLOCATOR_TO_AGENCY: () => `${ingestionURL}/agencies/map`,
  GET_PRODUCT_PREFERENCES: (
    query: string,
    enabled: boolean,
    offset = 0,
    limit = 10
  ) =>
    `${epsURL}/collections/eps/config/api/v1/products?query=${query}&enabled=${enabled}&offset=${offset}&limit=${limit}`,
  GET_BUCKET_PREFERENCES: (
    query: string,
    enabled: boolean,
    offset = 0,
    limit = 10
  ) =>
    `${epsURL}/collections/eps/config/api/v1/buckets?query=${query}&enabled=${enabled}&offset=${offset}&limit=${limit}`,
  GET_DB_COLUMNS: () => `${ingestionURL}/column-master`,
  DOWNLOAD_SAMPLE: `${ingestionURL}/allocations/template/download`,
  GET_CUSTOM_PRODUCT_LIST: `${epsURL}/collections/eps/config/api/v1/custom-product-list`,
  GET_CUSTOM_BUCKET_LIST: `${epsURL}/collections/eps/config/api/v1/custom-bucket-list`,
};
const trainingVideoEndPoints = {
  GET_TRAINING_VIDEOS: (limit: number, offset: number, query?: string) => {
    const base = `${emsServiceURL}/api/v1/compliance/training-videos?limit=${limit}&offset=${offset}`;
    return query ? `${base}&query=${encodeURIComponent(query)}` : base;
  },
  GET_TRAINING_VIDEO_DETAIL: (videoId: string) =>
    `${emsServiceURL}/api/v1/compliance/training-videos/${videoId}`,
};

const complianceEndPoints = {
  GET_AGENCY_DOCUMENTS: (filter: string, agencyId: string) =>
    `${emsURL}/ems/compliance/documents/api/v1/agency-documents?filter=${filter}&agencyId=${agencyId}`,
  UPLOAD_DOCUMENT: `${emsURL}/ems/compliance/documents/api/v1/upload-document`,
  SHOW_DOCUMENT: (entityDocumentId: string) =>
    `${emsURL}/ems/compliance/documents/api/v1/show-document?entityDocumentId=${entityDocumentId}`,
  DOWNLOAD_SAMPLE_DOCUMENT: (documentMasterId: string) =>
    `${emsURL}/ems/compliance/documents/api/v1/download-sample-document?documentMasterId=${documentMasterId}`,
  GET_AGENCY_DETAIL: (agencyId: string) =>
    `${emsURL}/ems/compliance/agency/api/v1/agency?agencyId=${agencyId}`,
  EDIT_DOCUMENT_STATUS: () =>
    `${emsURL}/ems/compliance/documents/api/v1/document/edit-status`,
  EDIT_DOCUMENT_DUE_DATE: () =>
    `${emsURL}/ems/compliance/documents/api/v1/document/edit-due-date`,

  // Folder
  GET_FOLDERS: (agencyId: string, allocatorId: string) =>
    `${emsURL}/ems/compliance/folders/api/v1/folders?agencyId=${agencyId}&allocatorId=${allocatorId}`,
  // Agency
  GET_AGENCIES: (allocatorId: string) =>
    `${emsURL}/ems/compliance/documents/api/v1/my-agency-list?allocatorId=${allocatorId}`,
  GET_PINCODES: (allocatorId: string) =>
    `${emsURL}/ems/compliance/agency/api/v1/my-agency-list/pincodes?allocatorId=${allocatorId}`,
  GET_CITIES: (allocatorId: string) =>
    `${emsURL}/ems/compliance/agency/api/v1/my-agency-list/cities?allocatorId=${allocatorId}`,
  GET_AREAS: (allocatorId: string) =>
    `${emsURL}/ems/compliance/agency/api/v1/my-agency-list/areas?allocatorId=${allocatorId}`,

  // Recordings
  GET_CALL_RECORDINGS: (
    allocatorId: string,
    uploadMonth: number,
    uploadYear: number
  ) =>
    `${emsURL}/ems/compliance/call-recordings/api/v1/my-agencies-summary?allocatorId=${allocatorId}&uploadMonth=${uploadMonth}&uploadYear=${uploadYear}&page=0&size=10`,
  GET_CALL_RECORDINGS_BY_AGENCY: (
    allocatorId: string,
    agencyId: string,
    month: number,
    year: number
  ) =>
    `${emsURL}/ems/compliance/call-recordings/api/v1/call-recordings?agencyId=${agencyId}&allocatorId=${allocatorId}&uploadMonth=${month}&uploadYear=${year}&page=0&size=10`,
  GET_CALL_RECORDINGS_BY_MONTH: (
    allocatorId: string,
    agencyId: string,
    uploadYear: number
  ) =>
    `${emsURL}/ems/compliance/call-recordings/api/v1/agency/summary?agencyId=${agencyId}&allocatorId=${allocatorId}&uploadYear=${uploadYear}&page=0&size=10`,
  DOWNLOAD_CALL_RECORDING: (recordingId: string) =>
    `${emsURL}/ems/compliance/call-recordings/api/v1/download-call-recording?recordingId=${recordingId}`,
  UPLOAD_CALL_RECORDINGS: () =>
    `${emsURL}/ems/compliance/call-recordings/api/v1/call-recordings`,
  GET_DISTINCT_YEARS: (agencyId: string, allocatorId: string) =>
    `${emsURL}/ems/compliance/call-recordings/api/v1/agency/distinct-years?agencyId=${agencyId}&allocatorId=${allocatorId}`,
};

const plannerConfigEndPoints = {
  GET_ALLOCATOR_LIST: (agencyId: string) =>
    `${discoveryURL}/agencies/${agencyId}/allocator-list`,
  GET_ALLOCATOR_LOB_LIST: (allocatorId: string) =>
    `${ingestionURL}/allocator-mappings/${allocatorId}`,
  GET_PLANNER_CONFIG: (agencyId: string) =>
    `${ingestionURL}/agencies/${agencyId}/planner-config/search`,
  CREATE_PLANNER_CONFIG: (agencyId: string) =>
    `${ingestionURL}/agencies/${agencyId}/planner-config`,
  UPDATE_PLANNER_CONFIG: (agencyId: string, id: string) =>
    `${ingestionURL}/agencies/${agencyId}/planner-config/${id}`,
  GET_ALL_ALLOCATORS: () => `${discoveryURL}/allocators/basic-info`,
};

const allAgentPerformanceEndpoints = {
  GET_AGENT_PERFORMANCE_CALL_METRICS: (
    supervisorId: string,
    startDate: string,
    endDate: string,
    limit: number,
    offset: number
  ) =>
    `${phygitalURL}/crm/api/v1/supervisor/agent-performance-call-metrics?supervisorId=${supervisorId}&startDate=${startDate}&endDate=${endDate}&limit=${limit}&offset=${offset}&=cc_supervisor`,
  GET_AGENT_PERFORMANCE_METRICS: (
    supervisorId: string,
    startDate: string,
    endDate: string,
    searchText: string,
    limit: number,
    offset: number
  ) =>
    `${phygitalURL}/crm/api/v1/supervisor/agent-performance-metrics?supervisorId=${supervisorId}&startDate=${startDate}&endDate=${endDate}&searchText=${searchText}&limit=${limit}&offset=${offset}`,
};

const fieldSupervisorDashboardEndpoints = {
  AGENT_WISE_SUMMARY: `${ucfURL}/ucf/dashboard/api/v1/agent-wise-summary`,
  DAY_WISE_VISIT_SUMMARY: `${ucfURL}/ucf/dashboard/api/v1/day-wise-visit-summary`,
  AGENT_VISIT_PERCENTAGE: `${ucfURL}/ucf/dashboard/api/v1/agent-visit-percentage`,
  AGENT_COLLECTION_PERCENTAGE: `${ucfURL}/ucf/dashboard/api/v1/agent-collection-percentage`,
  GET_AGENT_LIST: `${ucfURL}/ucf/dashboard/field/agent-list`,
  GET_DEVIATION_LIST: `${ucfURL}/ucf/dashboard/field/deviation-list`,
  GET_AGENT_ROUTE: `${ucfURL}/ucf/dashboard/field/deviation-route`,
};
const incentiveEndPoints = {
  GET_INCENTIVES: `${ucfURL}/api/v1/incentives`,
  CREATE_INCENTIVE: `${ucfURL}/api/v1/incentives`,
  GET_AGENTS: `${ucfURL}/api/v1/incentives/agents`,
  GET_INCENTIVE_BY_ID: (id: string) => `${ucfURL}/api/v1/incentives/${id}`,
  UPDATE_INCENTIVE_BY_ID: (id: string) => `${ucfURL}/api/v1/incentives/${id}`,
};
const dashboardEndPoints = {
  GET_ALL_PORTFOLIOS: (
    agencyId: string,
    allocatorId: string,
    page: number,
    pageSize: number
  ) =>
    `${ihsURL}/dashboard/api/v1/all-portfolios?agencyId=${agencyId}&allocatorId=${allocatorId}&page=${page}&pageSize=${pageSize}`,
  GET_PORTFOLIO_PERFORMANCE_SUMMARY: (allocationId: string) =>
    `${ihsURL}/dashboard/api/v1/portfolio-performance-summary?allocationId=${allocationId}`,
  GET_DISPOSITION_SUMMARY: (
    allocationId: string,
    agencyId: string,
    allocatorId: string
  ) =>
    `${ihsURL}/dashboard/api/v1/disposition-summary?allocationId=${allocationId}&agencyId=${agencyId}&allocatorId=${allocatorId}`,
  GET_EFFORT_METRIC_SUMMARY: (
    allocationId: string,
    agencyId: string,
    allocatorId: string,
    channelType?: string
  ) => {
    const baseUrl = `${ihsURL}/dashboard/api/v1/effort-metric-summary?allocationId=${allocationId}&agencyId=${agencyId}&allocatorId=${allocatorId}`;
    return channelType ? `${baseUrl}&channelType=${channelType}` : baseUrl;
  },
  POST_DISPOSITION_SUMMARY: () => `${lrsURL}/api/dashboard/disposition-summary`,
  POST_EFFORT_METRICS: () => `${lrsURL}/api/dashboard/effort-metrics`,
  GET_DASHBOARD_FILTERS: (
    allocatorId: string,
    startDate?: string,
    endDate?: string
  ) => {
    let url = `${lrsURL}/api/dashboard/filters?allocatorId=${allocatorId}`;
    if (startDate) url += `&startDate=${startDate}`;
    if (endDate) url += `&endDate=${endDate}`;
    return url;
  },
  POST_PORTFOLIO_METRICS: () => `${lrsURL}/api/dashboard/portfolio_performance`,
  POST_AGENCY_SUMMARY: () => `${lrsURL}/api/dashboard/agency-summary`,
  POST_VISIT_SUMMARY: () => `${lrsURL}/api/dashboard/visit-summary`,
};

// DID configuration
const didConfigurationEndPoints = {
  GET_DID_CONFIGURATION: () => `${ucfURL}/ucf/api/v1/telephony/did-mapping/all`,
  GET_AGENCIES: () => `${discoveryURL}/agencies/basic-info`,
  GET_DID_NUMBERS: () =>
    `${ucfURL}/ucf/api/v1/telephony/did-mapping/available-dids`,
  CREATE_DID: () => `${ucfURL}/ucf/api/v1/telephony/did-mapping/create`,
  UPDATE_DID: () => `${ucfURL}/ucf/api/v1/telephony/did-mapping/edit`,
  GET_DID_BY_AGENCY: (agencyId: string) =>
    `${ucfURL}/ucf/api/v1/telephony/did-mapping/agency/${agencyId}`,
  DOWNLOAD_DID: () => `${ucfURL}/ucf/api/v1/telephony/did-mapping/download`,
  UPLOAD_DID: (agencyId: string) =>
    `${ucfURL}/ucf/api/v1/telephony/did-mapping/agency/${agencyId}/upload`,
};

const emdProductBucketEndPoints = {
  GET_ALL_PRODUCTS: `${emsAgencyOnBoardingNoAuthURL}/v2/distinct-product?page=0&size=100`,
  GET_ALL_BUCKETS: `${emsAgencyOnBoardingNoAuthURL}/v2/distinct-bucket?page=0&size=100`,
};

const emailServiceEndPoints = {
  SEND_EMAIL: `${emsServiceURL}/api/email/send`,
  GET_EMAIL_TEMPLATES: (subDispositionId: string | null) =>
    `${ucfURL}/api/v1/email-templates${
      subDispositionId ? `?subDispositionId=${subDispositionId}` : ''
    }`,
};

const whatsappEndPoints = {
  GET_TEMPLATES: (borrowerId: string) =>
    `${ucfURL}/api/crm/whatsapp/templates?borrowerId=${borrowerId}`,
  GET_HISTORY: (
    agencyId: string,
    borrowerId: string,
    cursor?: string,
    limit = 20
  ) => {
    const params = new URLSearchParams({ limit: String(limit) });
    if (cursor) params.set('cursor', cursor);
    return `${ucfURL}/api/crm/whatsapp/history/${agencyId}/${borrowerId}?${params}`;
  },
  SEND_MESSAGE: () => `${ucfURL}/api/crm/whatsapp/send`,
  SSE_CONNECT: (agencyId: string, borrowerId: string) =>
    `${YUBI_GATEWAY_URL}/ucf-mobile-service/api/crm/whatsapp/sse/connect/${agencyId}/${borrowerId}`,
  GET_BADGE_COUNT: (date: string) => {
    const params = new URLSearchParams({ date });
    return `${ucfURL}/api/crm/whatsapp/badge-count?${params}`;
  },
  GET_WHATSAPP_MESSAGES: (
    fromDate: string,
    toDate: string,
    searchValue: string,
    page: number,
    size: number
  ) => {
    const params = new URLSearchParams({
      fromDate,
      toDate,
      searchValue,
      page: String(page),
      size: String(size),
    });
    return `${ucfURL}/api/crm/whatsapp/messages?${params}`;
  },
};

// Spocto domain IDs for different envs
/** Please DO NOT REMOVE below codes as this is required for Spocto domain users,
 * to resolve platform issue of multiple entities being related to these users in platform */
let SPOCTO_ID = '6735fbdbf1a5e20032cf8bb0'; // we're using Allset's ID for testing purpose for QA & stg
if (env === 'prd') {
  SPOCTO_ID = '686677bbb3710c0078211cf2';
} else if (env === 'uat') {
  SPOCTO_ID = '67b756b95482f8005101ccbb';
} else if (env === 'stg') {
  SPOCTO_ID = '673ace90ca8a3900473eefc4'; // we're using Allset's ID for testing purpose for QA & stg
}

export const scoreEndpoints = {
  GET_SCORE_ALLOCATIONS: (agencyId: string) =>
    `${ingestionURL}/agencies/${agencyId}/score/allocations`,
  DOWNLOAD_SCORED_FILE: (allocationId: string) =>
    `${ingestionURL}/allocations/${allocationId}/scored-download`,
  UPLOAD_SCORE_FILE: (agencyId: string) =>
    `${ingestionURL}/agencies/${agencyId}/score/upload`,
};

const ANALYSIS_BASE = `https://${env}-analysis-wb-service.yucollect${
  env === 'prd' ? '.com' : '.in'
}/api/v1`;

export const agentEndpointsAI = {
  LIST_AGENTS: `${ANALYSIS_BASE}/agents/projects/yucollect/agents`,
};

export const chatEndpoints = {
  START_SESSION: `${ANALYSIS_BASE}/chat/start`,
  SEND_MESSAGE: `${ANALYSIS_BASE}/chat/message`,
  STREAM: (sessionId: string) =>
    `${ANALYSIS_BASE}/chat/stream?session_id=${sessionId}`,
  CANCEL_SESSION: `${ANALYSIS_BASE}/chat/cancel`,
  MESSAGES_FOR_PRINT: (sessionId: string) =>
    `${ANALYSIS_BASE}/chat/message-for-print?session_id=${sessionId}`,
  EXPORT_PDF: `${ANALYSIS_BASE}/chat/export-pdf`,
};

export const corporaEndpoints = {
  LIST: `${ANALYSIS_BASE}/corpora`,
  GET: (id: string) => `${ANALYSIS_BASE}/corpora/${id}`,
  CREATE: `${ANALYSIS_BASE}/corpora`,
  DELETE: (id: string) => `${ANALYSIS_BASE}/corpora/${id}`,
  SEARCH: `${ANALYSIS_BASE}/corpora/search`,
};

export const documentsEndpoints = {
  LIST: (corpusId: string) => `${ANALYSIS_BASE}/corpora/${corpusId}/documents`,
  GET: (id: string) => `${ANALYSIS_BASE}/documents/${id}`,
  UPLOAD: (corpusId: string) =>
    `${ANALYSIS_BASE}/corpora/${corpusId}/documents`,
  DELETE: (id: string) => `${ANALYSIS_BASE}/documents/${id}`,
};

export const ragConfigEndpoints = {
  GET_CONFIG: `${ANALYSIS_BASE}/config`,
};

export {
  advancedPlannerEndPoints,
  agency,
  agencyOnboarding,
  agentEndpoints,
  agentGroupEndpoints,
  agentListEndpoints,
  allAgentPerformanceEndpoints,
  allocationEndpoints,
  allocationEngineEndpoints,
  allocator,
  callCampaignEndpoints,
  callPlannerEndPoints,
  campaignEndPoints,
  campaignEndpoints,
  campaignMetrics,
  campaignPlanner,
  columnMappingEndPoints,
  complianceEndPoints,
  trainingVideoEndPoints,
  contentManagement,
  crmEndPoints,
  dashboardEndPoints,
  didConfigurationEndPoints,
  discoveryNoAuthURL,
  discoveryURL,
  emailServiceEndPoints,
  emdProductBucketEndPoints,
  fieldPlannerEndPoints,
  fieldSupervisorDashboardEndpoints,
  hierarchyManagementEndPoint,
  ihsURL,
  incentiveEndPoints,
  ingestionURL,
  localHostName,
  locationManagementEndPoint,
  manageAgency,
  plannerConfigEndPoints,
  redirectServiceUrl,
  reportsEndPoints,
  segmentsEndPoints,
  settingsEndpoints,
  SPOCTO_ID,
  supervisorCRMEndPoints,
  ucfURL,
  userEndpoints,
  yucollectAdmin,
  whatsappEndPoints,
};
